import React, { useState } from 'react';
import { swalSuccess, swalError } from '../utils/alert';
import './FormPage.css'; // Assuming a generic form styling

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('/api/forgot-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        let msg = data.message;
        if (data.reset_link) {
          msg += ' Link para redefinição (apenas para desenvolvimento): ' + data.reset_link;
        }
        swalSuccess(msg);
      } else {
        swalError(data.message || 'Erro ao enviar o link de redefinição.');
      }
    } catch (err) {
      swalError('Erro de rede. Tente novamente mais tarde.');
    }
  };

  return (
    <div className="form-page-container">
      <form onSubmit={handleForgotPassword} className="form-card">
        <h2>Esqueceu a Senha?</h2>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="seu@email.com"
            required
          />
        </div>
        <button type="submit" className="submit-button">Enviar Link de Redefinição</button>
        <p className="back-to-login-link">
          <a href="/login">Voltar para o Login</a>
        </p>
      </form>
    </div>
  );
};

export default ForgotPasswordPage;
